// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__bElrR","desc":"Empty_desc__VT9Lp","btn":"Empty_btn__cs8cE"};